export default "__VITE_ASSET__D7ACUA7D__"